
/** npm import */
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router';
// import ReactDatatable from '@ashvin27/react-datatable';
import ReactDatatable from "react-data-table-component";
/** local file import */
import Header from '../Layout/header'
import Subscriber from '../Layout/subscribe';
import Footer from '../Layout/footer';
import config from '../helper/config';
import { DepositSupportAction, GetuserData } from '../Axios/user.axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { DateTimeForm, FirstCaps, NumANdDotOnly, isEmpty } from '../helper/common';
import Select from 'react-select';
import { isAddress } from 'web3-validator';



/** code start */

const initform = {
    Reason: null,
    TXID: '',
    Coin: null,
    Network: null,
    RecieverAddress: '',
    Amount: '',
    Attachment: '',
}

const ReasonOption = [
    {
        label: 'Forgot or filled in wrong memo/tag',
        value: 'Forgot or filled in wrong memo/tag',
    },
    {
        label: 'Deposited an unlisted/delisted coin',
        value: 'Deposited an unlisted/delisted coin',
    },
    {
        label: 'Another exchange refunded the deposit to Binance',
        value: 'Another exchange refunded the deposit to Binance',
    },
    // {
    //     label: "Don't know/None of the above",
    //     value: "Don't know/None of the above",
    // },
]

const CoinOption = [
    {
        label: 'BNB',
        value: 'BNB',
    },
    {
        label: 'ETH',
        value: 'ETH',
    },
]

const NetworkOption = [
    {
        label: 'BNB',
        value: 'BNB',
    },
    {
        label: 'ETH',
        value: 'ETH',
    },
]


export default function DepositSupport () {

    const [attachmentName, setAttachmentName] = useState("Click To Choose");

    const attachmentRef = useRef(null)
    const userdata = useSelector((state)=>state?.LoginReducer?.User)
    const navigate = useNavigate()


    const [ SupportTicketList, SetSupportTicketList ] = useState([])
    const [formdata, SetFormData] = useState(initform);
    const [Errors, SetErrors] = useState({});
    const [Disable, SetDisable ] = useState(false);
    const [DisableStatus, SetDiableStatus] = useState(false);

    const tableCustomStyles = {
        headRow: {
          style: {
            color:'#000',
            fontSize: "14px",
            border:"1px solid black"
            // backgroundColor: '#e7eef0'
          },
        },
        striped: {
            default: 'red'
        },
        rows: {
            style: {
                minHeight: '72px', // override the row height
            },
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
            },
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px',
            },
        },
      }
    
    const columns = [
        {
          id: 1,
          name: "Created Date",
        //   selector: (row) => row.createdAt,
        cell: rec => <div>{DateTimeForm(rec?.createdAt,true)}</div>,
        //   sortable: true,
          reorder: true,
        },
        {
          id: 2,
          name: "Reason",
          selector: (row) => row.Reason,
        //   sortable: true,
          reorder: true,
        },
        {
          id: 3,
          name: "TxId/TxHash",
          selector: (row) => row.TXID,
        //   sortable: true,
          right: true,
          reorder: true,
        },
        {
            id: 4,
            name: "Ticket Status",
            selector: (row) => row.ticketStatus,
          //   sortable: true,
            right: true,
            reorder: true,
          },
      ]
    
    
    // [

    //     {
    //         key: "createdAt",
    //         name: "Created Date",
    //         className: "w_150 text-center",
    //         align: "center",
    //         width: 150,
    //         // sortable: true,
    //         cell: rec => <div>{DateTimeForm(rec?.createdAt,true)}</div>
    //     },

    //     {
    //         key: "Reason",
    //         name: "Reason",
    //         className: "w_250 text-center",
    //         align: "center",
    //         width: 250,
    //         // sortable: true,
    //         cell: rec => <div>{rec?.Reason}</div>
    //     },
    //     {
    //         key: "TXID",
    //         name: "TxId/TxHash",
    //         className: "w_250 text-center",
    //         align: "center",
    //         width: 250,
    //         // sortable: true,
    //         cell: rec => <div>{rec?.TXID}</div>
    //     },
    //     {
    //         key: "status",
    //         name: "Ticket Status",
    //         className: "w_150 text-center",
    //         align: "center",
    //         width: 150,
    //         sortable: true,
    //         cell: rec =>
    //             <div>{FirstCaps(rec?.ticketStatus)}</div>
    //     },

    //     // {
    //     //     key: "subject",
    //     //     text: "Subject",
    //     //     className: "w_200 text-center",
    //     //     align: "center",
    //     //     width: 200,
    //     //     sortable: true,
    //     //     cell: rec => <div>{rec?.Subject}</div>
    //     // },
    // ]

    useEffect(() => {
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        if (cookie) {
            GetUserProfile(cookie);
        }
        else {
            navigate('/')
        }
    }, [])

    const GetUserProfile = async(cookie) => {
        if(!DisableStatus){
            SetDiableStatus(true);
            let resp = await GetuserData({ data: cookie, kyc: false })
            if(resp?.status){
            }
            else{
                navigate('/');
            }
            SetDiableStatus(false);
        }
    }

    useEffect(()=>{
        if (userdata?.payload) {
            GetSupportTicket();
        }
    },[userdata?.payload])

    const GetSupportTicket = async() => {
        try{
            let resp = await DepositSupportAction({ action: "get", UserId: userdata?.payload?._id })
            console.log('DepositSupportAction_resp',resp)
            SetSupportTicketList(resp?.data?resp?.data:[]);
        }
        catch(err){
            console.log('GetSupportTicket_error',err)
        }
    }

    const handleUploadAttachment = () => {
        attachmentRef.current.click()
    }

    const OnChange = (e,name) => {
        SetErrors({});
        if(name){
            if(name == 'Coin' || name == 'Network'){
                SetFormData({
                    ...formdata,
                    ...{[name]:e}
                })
            }
            else if(name == "Reason"){
                SetFormData({
                    ...formdata,
                    ...{
                        [name]:e?.value,
                        Network: null,
                        RecieverAddress: '',
                    }
                })
            }
        }
        else{
            
            let id = e?.target?.id;
            let value = e?.target?.value;
            SetFormData({...formdata,...{[id]:( id == 'Amount' ? NumANdDotOnly(value) : value)}});
        }
    }

    const HandleFile = (e) => {
        SetErrors({});
        let file = e?.target?.files?.[0];
        let id = e?.target?.id;
        if(file){
            setAttachmentName(file?.name);
            if(file?.type?.includes('image')||file?.type?.includes('video')||file?.type?.includes('pdf')){
                SetFormData({
                    ...formdata,
                    ...{
                        [id]: file
                    }
                })
            }
            else{
                toast.error("Upload Files that is pdf or image or video")
            }
        }
    }

    const Validate = () => {
        let errors = {};
        if(isEmpty(formdata?.Reason)){
            errors.Reason = "Enter Reason";
        }
        else{
            if(formdata?.Reason!='Forgot or filled in wrong memo/tag'){
                if(isEmpty(formdata?.Network)){
                    errors.Network = "Select Network"
                }
                if(isEmpty(formdata?.RecieverAddress)){
                    errors.RecieverAddress = "Enter Reciever Address"
                }
                else if(!isAddress(formdata?.RecieverAddress)){
                    errors.RecieverAddress = "Enter Valid Wallet Address";
                }
            }
        }
        if(isEmpty(formdata?.TXID)){
            errors.TXID = "Enter TxId/TxHash";
        }
        if(isEmpty(formdata?.Coin)){
            errors.Coin = "Select Coin";
        }
        if(isEmpty(formdata?.Amount)){
            errors.Amount = "Enter Deposit Amount";
        }
        return errors
    }

    const Submit = async () => {
        SetDisable(true);
        let error = Validate();
        if(isEmpty(error)){
            let resp = await DepositSupportAction({ 
                Reason: formdata?.Reason,
                TXID: formdata?.TXID,
                Coin: formdata?.Coin,
                Network: formdata?.Network,
                RecieverAddress: formdata?.RecieverAddress,
                Amount: formdata?.Amount,
                Attachment: formdata?.Attachment, 
                UserId: userdata?.payload?._id,
                action: 'save',
            });
            console.log('DepositSupportActionresp',resp);
            if(resp?.status){
                toast.success("Report Raised Successfully");
                SetErrors({});
                SetFormData(initform);
                GetSupportTicket();
                setAttachmentName("Click To Choose")
            }
            else{
                toast.error(resp?.msg?resp?.msg:"Try-Again");
            }
        }
        else{
            toast.error("Fix all Validations")
            SetErrors(error);
        }
        SetDisable(false);
    }

    return (
        <div>
            <Header />

            <section className='custom_section'>
                <div className='container py-4 py-md-5'>
                    <div>


                        <div className='row justify-content-center'>
                            <div className='col-12 col-sm-11 col-md-9 col-lg-8'>
                                <h2 className='color-brand-1 mb-4'>Crypto deposit dispute support</h2>
                                <div className='row mx-auto'>
                                <div className='col-12 col-md-12'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Select the reason why your deposit hasn't arrived</label>
                                            <div className="form-group mb-4">
                                                <Select
                                                    classNamePrefix={"form-control"}
                                                    type="text"
                                                    name="name"
                                                    placeholder="e.g.Redeemable"
                                                    id='Reason'
                                                    onChange={(e)=>OnChange(e,"Reason")}
                                                    value={{ label: isEmpty(formdata?.Reason) ? "select reason"  : formdata?.Reason , value: isEmpty(formdata?.Reason) ? "select reason"  : formdata?.Reason }}
                                                    options={ReasonOption}
                                                />
                                                {
                                                    Errors?.Reason 
                                                    ?
                                                    <span className="error-msg">{Errors?.Reason}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-12'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>TxID/TxHash</label>
                                            <div className="form-group mb-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="e.g.TxID"
                                                    id='TXID'
                                                    onChange={(e)=>OnChange(e)}
                                                    value={formdata?.TXID||''}
                                                />
                                                {
                                                    Errors?.TXID 
                                                    ?
                                                    <span className="error-msg">{Errors?.TXID}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-12 mt-3 mt-md-0'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Coin</label>
                                            <div className="form-group mb-4">
                                                <Select
                                                    classNamePrefix={"form-control"}
                                                    type="text"
                                                    name="name"
                                                    placeholder="e.g.Redeemable"
                                                    id='Coin'
                                                    onChange={(e)=>OnChange(e,"Coin")}
                                                    value={{ label: formdata?.Coin?.label ?? "Select Coin", value: formdata?.Coin?.value ?? "Select Coin" }}
                                                    options={CoinOption}
                                                />
                                                {
                                                    Errors?.Coin 
                                                    ?
                                                    <span className="error-msg">{Errors?.Coin}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        formdata?.Reason != "Forgot or filled in wrong memo/tag"
                                            ?
                                            <>
                                                <div className='col-12 col-md-12 mt-3 mt-md-0'>
                                                    <div>
                                                        <label className='fw-bold mb-2 profile_label'>Network</label>
                                                        <div className="form-group mb-4">
                                                            <Select
                                                                classNamePrefix={"form-control"}
                                                                type="text"
                                                                name="name"
                                                                placeholder="e.g.Redeemable"
                                                                id='Network'
                                                                onChange={(e) => OnChange(e, "Network")}
                                                                value={{ label: formdata?.Network?.label ?? "Select Network", value: formdata?.Network?.value ?? "Select Network" }}
                                                                options={NetworkOption}
                                                            />
                                                            {
                                                                Errors?.Network
                                                                    ?
                                                                    <span className="error-msg">{Errors?.Network}</span>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-12 col-md-12 mt-3 mt-md-0'>
                                                    <div>
                                                        <label className='fw-bold mb-2 profile_label'>Deposit Recieving Address</label>
                                                        <div className="form-group mb-4">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                name="name"
                                                                placeholder="Enter Reciever Address"
                                                                id='RecieverAddress'
                                                                onChange={(e) => OnChange(e)}
                                                                value={formdata?.RecieverAddress||''}
                                                            />
                                                            {
                                                                Errors?.RecieverAddress
                                                                    ?
                                                                    <span className="error-msg">{Errors?.RecieverAddress}</span>
                                                                    :
                                                                    <></>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <></>
                                    }
                                    <div className='col-12 col-md-12 mt-3 mt-md-0'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Deposit Amount</label>
                                            <div className="form-group mb-4">
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Amount"
                                                    id='Amount'
                                                    onChange={(e)=>OnChange(e)}
                                                    value={formdata?.Amount||''}
                                                />
                                                {
                                                    Errors?.Amount 
                                                    ?
                                                    <span className="error-msg">{Errors?.Amount}</span>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row mx-auto'>
                                    <div className='col-12 col-md-12'>
                                        <div>
                                            <label className='fw-bold mb-2 profile_label'>Attachment
                                                <span className='proile_label_span'> (Image should allowed only pdf/docx/jpg/png)</span>
                                            </label>

                                            <div className='file_name_wrapper' onClick={handleUploadAttachment}>
                                                {attachmentName}
                                            </div>

                                            <div className="form-group  d-none">
                                                <input
                                                    className="form-control"
                                                    type="file"
                                                    ref={attachmentRef}
                                                    name="name"
                                                    placeholder="e.g.Redeemable"
                                                    onChange={(e) => { HandleFile(e) }}
                                                    id='Attachment'
                                                />

                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-12 mt-4 d-flex align-items-end'>
                                        <button className='btn btn-brand-lg btn-full font-md-bold' style={{ maxWidth: "130px" }} onClick={()=>Submit()} disabled={Disable}>Submit</button>
                                    </div>
                                </div>
                                <div className="card_table mt-5">
                                    <ReactDatatable
                                   
                                        data={SupportTicketList}
                                        columns={columns}
                                        pagination
                                        customStyles={tableCustomStyles}

                                        // selectableRows
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Subscriber />
            <Footer />
        </div>
    )
}
